import { setPropertyPathSoftBounds } from '@store/slices/sceneSlice'
import { put } from 'redux-saga/effects'
import {
  BoundsVariant,
  PropertyPanelPath,
  PropertySoftBoundsHaveChangedData
} from '@services/engine/types'

export function* handlePropertySoftBoundsHaveChanged(
  data: PropertySoftBoundsHaveChangedData
) {
  const { path, min, max } = data
  yield updateSoftBound(path, min, max)
}

function* updateSoftBound(
  propertyPath: PropertyPanelPath,
  softMin: BoundsVariant,
  softMax: BoundsVariant
) {
  yield put(setPropertyPathSoftBounds({ propertyPath, softMin, softMax }))
}
